(function (global) {
  'use strict';

  // A theme can include this asset more than once. Mount each section once.
  if (global.AffiliateThemeV2) return;
  const mounted = new WeakSet();

  function initialize(documentRef = document) {
    documentRef.querySelectorAll('[data-affiliate-v2-section]').forEach((section) => {
      if (mounted.has(section)) return;
      mounted.add(section);
      const notice = section.querySelector('[data-affiliate-v2-notice]');
      const kind = section.dataset.affiliateV2Section;
      const root = section.querySelector(kind === 'capture' ? '#affiliate-capture-root' : '#affiliate-portal-root');
      if (section.dataset.designMode === 'true') {
        if (root) root.hidden = true;
        if (notice) notice.textContent = 'Save the reviewed program settings, then open the storefront preview to test this page.';
        return;
      }
      try {
        const api = new URL(section.dataset.apiBase || '');
        const programSlug = section.dataset.programSlug || '';
        if (!root || api.protocol !== 'https:' || api.username || api.password || api.search || api.hash
          || !/^[a-z0-9][a-z0-9-]{1,98}[a-z0-9]$/.test(programSlug)) throw new Error('Invalid configuration');
        const options = { root, apiBase: api.href.replace(/\/+$/, ''), programSlug };
        if (kind === 'capture') {
          // Only the untrusted code comes from the URL. Tenant/program/API never do.
          options.initialCode = new URLSearchParams(global.location.search).get('code') || '';
          options.cartPersistence = { enabled: section.dataset.cartPersistence === 'true', endpoint: '/cart/update.js' };
          global.AffiliateCaptureV2.mount(options);
        } else if (kind === 'portal') {
          options.capturePageUrl = section.dataset.capturePageUrl || '';
          global.AffiliatePortalV2.mount(options);
        } else throw new Error('Unknown section');
        if (notice) notice.hidden = true;
      } catch (_) {
        if (root) root.hidden = true;
        if (notice) notice.textContent = 'This referral page is not available yet. Please contact the store team.';
      }
    });
  }

  global.AffiliateThemeV2 = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})(window);
